import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { baseURL, imagenesURL, sistemaURL } from '../url.js';
import '../../css/Components/Cart/Cart.css';
import whatsappIcon from '../../images/wpp.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from "react-router-dom";
import moneda from '../moneda.js';
import moment from 'moment';
import Swal from 'sweetalert2';
import { renderNumero } from '../../js/funcionesGenerales.js';
export default function Cart() {
    const [cartItems, setCartItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen2, setModalIsOpen2] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        const fetchCartItems = async () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || [];
            //console.log("mi cart", cart)
            setCartItems(cart);
            setLoading(false);
        };

        fetchCartItems();
    }, [isFocused]);
    useEffect(() => {
        getSucursales()
    }, [])
    const obtenerImagen = (item) => {
        return imagenesURL + item.details.imagen;
    };

    const openModal = () => {
        setModalIsOpen(true);
        setIsFocused(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setIsFocused(false);
    };

    const openModal2 = () => { setModalIsOpen2(true); };

    const closeModal2 = () => { setModalIsOpen2(false); };

    const removeFromCart = (id) => {
        const updatedCart = cartItems.filter(item => item.idProducto !== id);
        setCartItems(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    const clearCart = () => {
        setCartItems([]);
        localStorage.removeItem('cart');
    };
    const handleWhatsappMessage = () => {
        let totalPrice = 0;

        cartItems.forEach(item => {
            totalPrice += item.precio * item.cantidad;
        });
        const formattedTotalPrice = totalPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        const cartDetails = cartItems.map((item) => (
            `\n✅ *${item.details.nombre}* \n       Cantidad: ${item.cantidad}\n       Precio: ${moneda} ${item.details.precio_venta?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")} \n       ${item?.item}`
        ));

        const message = `¡Hola! 🌟 Estoy interesado en encargar:\n${cartDetails.join('')}\n------------------------------------>\n\n------------------------------------>\n\n*Total: ${moneda} ${formattedTotalPrice}*`;
        const phoneNumber = "+51951182135"
        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;

        window.open(whatsappUrl, '_blank');
        setModalIsOpen(false);
        setModalIsOpen2(false);
    };

    // Función para aumentar la cantidad de un producto en el carrito
    const increaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        updatedCartItems[index].cantidad += 1;
        setCartItems(updatedCartItems);
        localStorage.setItem('cart', JSON.stringify(updatedCartItems));
    };

    // Función para disminuir la cantidad de un producto en el carrito
    const decreaseQuantity = (index) => {
        const updatedCartItems = [...cartItems];
        if (updatedCartItems[index].cantidad > 1) {
            updatedCartItems[index].cantidad -= 1;
            setCartItems(updatedCartItems);
            localStorage.setItem('cart', JSON.stringify(updatedCartItems));
        }
    };

    const [contacto, setContacto] = useState({
        nombres_completos: '',
        numero_contacto: '',
        numero_documento: '',
        mensaje_referencial: '',
        id_sucursal: 1
    })
    const manejadorContacto = (e) => {
        const { name, value } = e.target
        setContacto({
            ...contacto,
            [name]: value
        })
    }
    const [sucursales, setSucursales] = useState([])
    const getSucursales = () => {
        fetch(`${sistemaURL}/web/getSucursales`, {
            method: 'GET',
        }).then(response => response.json())
            .then(data => { setSucursales(data || []); })
            .catch(error => console.error('Error al cargar contactos:', error));
    }
    const validarPedido = () => {
        if (contacto.nombres_completos == "" || contacto.numero_contacto == "" || contacto.id_sucursal == 0 || contacto.numero_documento == "") {
            Swal.fire({
                title: 'Error',
                text: "Por Favor rellene todos los campos",
                icon: 'error',
                confirmButtonText: 'OK',
                timer: 10000,
            })
            return false
        }
        return true
    }
    const realizarPedido = () => {
        if (!validarPedido()) {
            return
        }
        if (!window.confirm("Confirmar los datos con el pedido")) {
            return
        }
        //console.log("enviando", { cliente: contacto, items: JSON.parse(productosCarrito) })
        //return
        const items = []
        cartItems.forEach((item) => {
            items.push({
                ...item,
                producto: {
                    id: item.idProducto,
                },
            })
        })
        fetch(`${sistemaURL}/web/guardarPedido`,
            {
                method: "POST", // or 'PUT'
                body: JSON.stringify({
                    cliente: contacto,
                    pedido: {
                        fecha_registro: moment().format("YYYY-MM-DD"),
                        fecha_emision: moment().format("YYYY-MM-DD"),
                        id_sucursal: contacto.id_sucursal,
                        id_moneda: 12,
                        id_tipo_pago: 16,
                        dias_validez: 3,
                        estado_registro: 1,
                        direccion_cliente_cotizacion: 's/d',
                        tipo_cambio: 1.000,
                        id_venta: 0,
                    },
                    //items: JSON.parse(cartItems)
                    items: items
                }), // data can be `string` or {object}!
                headers: {
                    "Content-Type": "application/json",
                }
            })
            .then(response => response.json())
            .then(data => {
                //console.log(data)
                if (data["response"]) {
                    Swal.fire({
                        title: 'Pedido Registrado Con éxito',
                        text: 'Gracias por realizar tu pedido, en unos momentos nos contacteremos contigo para coordinar la entrega,' +
                            'por favor guarda el código de pedido: [ PEDIDO COD ' + data["getID"] + ' ]',
                        icon: 'success',
                        confirmButtonText: 'OK',
                    }).then((result) => {
                        clearCart()
                        window.open("/", "_self");
                    })
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: "Disculpa no pudimos registrar tu pedido, por favor recargar la página e intenta de nuevo",
                        icon: 'error',
                        confirmButtonText: 'OK',
                        timer: 10000,
                    })
                }
                //cerrarModalPedido()
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    }
    return (
        <div>

            <button onClick={openModal} className='cartIcon'>
                {
                    cartItems?.length >= 1 && (
                        <span>{cartItems.length}</span>
                    )

                }
                <FontAwesomeIcon icon={faShoppingCart} />
            </button>

            <Modal
                isOpen={modalIsOpen}
                className="modal-cart"
                overlayClassName="overlay-cart"
                onRequestClose={closeModal}
            >
                <div className='deFLex'>
                    <button onClick={closeModal} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                    <button onClick={clearCart} className='deleteToCart'>Vaciar carrito</button>
                </div>
                {cartItems?.length === 0 ?
                    (<p className='nohay'> No hay productos</p>)
                    : (<>
                        <div className="modal-content-cart">


                            {loading ? (
                                <p>Cargando...</p>
                            ) : (
                                <div>

                                    {cartItems.map((item, index) => (
                                        <div key={index} className='cardProductCart' >
                                            <Anchor to={`/producto/${item?.idProducto}/${item?.details?.nombre?.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={obtenerImagen(item)} alt="imagen" />
                                            </Anchor>
                                            <div className='cardProductCartText'>
                                                <h3>{item.details.nombre}</h3>
                                                <span>
                                                    {item?.item?.map((sabor, index2) => (
                                                        <span key={index2}> {sabor}</span>
                                                    ))}
                                                </span>
                                                <strong>{moneda} {renderNumero(item?.details.precio_venta)}</strong>
                                            </div>
                                            <div className='deColumn'>
                                                <button onClick={() => removeFromCart(item.idProducto)} className='deleteCart'>  <FontAwesomeIcon icon={faTrash} /></button>
                                                <div className='deFlexCantidad'>
                                                    <button onClick={() => decreaseQuantity(index)}>-</button>
                                                    <span>{item.cantidad}</span>
                                                    <button onClick={() => increaseQuantity(index)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className='deColumnCart'>

                            <h4>Total: {moneda} {renderNumero(cartItems.reduce((a, b) => a + b.details.precio_venta, 0))}</h4>

                            <div className='deFLexBtns'>
                                {/* <button className='btnWpp' onClick={openModal2}>
                                    Pedir por  WhatsApp<img src={whatsappIcon} alt="WhatsApp" />
                                </button> */}
                                <button className='btn ' onClick={openModal2}>
                                    Realizar Pedido
                                </button>
                            </div>
                        </div>

                        <Modal
                            isOpen={modalIsOpen2}
                            onRequestClose={closeModal2}
                            className="modal-cart"
                            overlayClassName="overlay-cart"
                        >
                            <div className='deFLex'>
                                <button onClick={closeModal2} ><FontAwesomeIcon icon={faArrowLeft} />  </button>
                                <h4>Datos del Pedido</h4>
                            </div>
                            <div className="modal-send-form">

                                <small>Por favor llene sus datos, Nos contactaremos con usted en el breve plazo.</small>
                                <hr />
                                <div className='deFLexRadio'>
                                    <label>Sucursal Recojo</label>
                                    <select className="form-control select form-select" name="id_sucursal" value={contacto.id_sucursal} onChange={manejadorContacto} >
                                        <option value={0}>{"Seleccione Sucursal"}</option>
                                        {sucursales.map((item, key) => (
                                            <option key={key} value={item.id}>{item.nombre + " " + item.direccion}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className='deFLexInput'>
                                    <label>DNI / RUC</label>
                                    <input maxLength="15" type="text" name="numero_documento"
                                        value={contacto.numero_documento} placeholder="Numero Documento" onChange={manejadorContacto} />
                                </div>
                                <div className='deFLexInput'>
                                    <label >Nombres Completos <span className='obligatorio'>*</span></label>
                                    <input maxLength="100" type="text" className="form-control " name="nombres_completos"
                                        value={contacto.nombres_completos} placeholder="Denominacion" onChange={manejadorContacto} />
                                </div>
                                <div className='deFLexInput'>
                                    <label >Número Contacto <span className='obligatorio'>*</span></label>
                                    <input maxLength="30" type="text" className="form-control " name="numero_contacto"
                                        value={contacto.numero_contacto} placeholder="Prefencialmente WhatsApp" onChange={manejadorContacto} />
                                </div>
                                <div className='deFLexInput'>
                                    <label  >Mensaje Referencial</label>
                                    <textarea className="form-control " name="mensaje_referencial" value={contacto.mensaje_referencial} onChange={manejadorContacto} >
                                    </textarea>
                                </div>

                                {/* <div className='deFLexRadio'>
                                    <label>Formas de pago</label>
                                    <div >
                                        <input
                                            type="radio"
                                            id="efectivo"
                                            name="paymentMethod"
                                            value="efectivo"
                                            checked={paymentMethod === 'efectivo'}
                                            onChange={() => setPaymentMethod('efectivo')}
                                        />
                                        <label htmlFor="efectivo">Efectivo</label>
                                    </div>
                                    <div >
                                        <input
                                            type="radio"
                                            id="transferencia"
                                            name="paymentMethod"
                                            value="transferencia"
                                            checked={paymentMethod === 'transferencia'}
                                            onChange={() => setPaymentMethod('transferencia')}
                                        />
                                        <label htmlFor="transferencia">Transferencia</label>
                                    </div> 
                                </div> */}
                                {/* <input
                                    type="text"
                                    id="codigo"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    placeholder='Codigo de descuento (opcional)'
                                /> */}
                                {/* <button onClick={handleWhatsappMessage} className='btn'>Enviar</button> */}
                                <button onClick={realizarPedido} className='btn'>Enviar</button>

                            </div>

                        </Modal>

                    </>)}

            </Modal>
        </div >
    );
}
